import moment from 'moment';
import momentTz from 'moment-timezone'
export const messageType = {
  BROKER: 'broker',
  BID: 'bid',
  VERIFY: 'verify',
  TRACKING: 'tracking',
  //VERSION: 'version',
  BOOK: 'book',
}

export const messageTypeValues = Object.values(messageType)

export const subTypes = {
  BROKER_OFFER: 'broker_offer',
  BROKER_MESSAGE: 'broker_message',
  BID_REPLY: 'bid_reply',
  BID_AWARD: 'bid_awarded',
  BID_EXPIRE: 'bid_timeout',
  BID_DROP: 'bid_shipment_drop',
  VERIFY_RESULT: 'verify_result',
  TRACKING_UPDATE: 'tracking_update',
  VERSION_UPDATE: 'version_update',
  BOOK_REPLY: 'book_reply',
  BOOK_LOADSMART: 'book_loadsmart',
  VERIFY_LOADSMART: 'verify_loadsmart'
}

export const timeFormat = (timestamp) => {
  const time = moment(timestamp);
  const now = moment(Date.now());
  if(time.year() === now.year() && time.dayOfYear() === now.dayOfYear()) {
    return time.format("hh:mm A") // 08:14 AM
  }
  return time.format("ll") // Mar 15, 2021
}


export const timeZoneIANA = {
  'CST':"America/Chicago",
  'MST':"America/Denver",
  'PST':"America/Los_Angeles",
  'AKST':"America/Anchorage",
  'EST':'America/New_York'
}



export const formatTimeTz = (time, format , tz) => {
  return timeTz(time, tz).format(format);
}

export const timeTz = (time, tz) => {
  return momentTz.tz(time, timeZoneIANA[tz])
} 


// WEBPACK FOOTER //
// ./src/pages/MessagePush/uilts.js